<template>
  <FieldMultiSelect
    :label="label"
    :state="state"
    :disabled="disabled"
    :is-required="isRequired"
    :class-label="classLabel"

    :placeholder="placeholder"

    v-model="selected"

    :use-input="false"
    :allow-add-options="false"

    :option-value="optionValue"
    :option-label="optionLabel"
    :option-description="optionDescription"

    :options="options"
  />
</template>

<script>
import FieldMultiSelect from '@/components/forms/FieldMultiSelect'

export default {
  components: {
    FieldMultiSelect
  },

  props: {
    value: {},

    optionValue: {
      type: String,
      default: 'id'
    },

    optionLabel: {
      type: String,
      default: 'name'
    },

    optionDescription: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    state: Object,
    label: String,
    isRequired: Boolean,
    classLabel: String,
    apiOptions: Function
  },

  data () {
    return {
      options: [],
      selected: toArray(this.value)
    }
  },

  computed: {
    placeholder () {
      const hasValue = Array.isArray(this.selected) && this.selected.length
      return hasValue ? '' : 'Selecionar'
    }
  },

  mounted () {
    const vue = this

    vue.apiOptions({ limit: 9999 }).then(({ rows }) => {
      vue.options = rows
    })
  },

  watch: {
    selected (selected) {
      let input = toArray(selected)
      if (!input.length) input = null

      let vModel = toArray(this.value)
      if (!vModel.length) vModel = null

      if (isEqual(input, vModel)) return

      this.$emit('input', input)
    },

    value (value) {
      const vue = this

      let vModel = toArray(value)
      if (!vModel.length) vModel = null

      let selected = toArray(vue.selected)
      if (!selected.length) selected = null

      if (isEqual(vModel, selected)) return

      vue.selected = vModel
    }
  }
}

const toArray = (val) => {
  if (Array.isArray(val)) return [...val]
  return val ? [val] : []
}

const isEqual = (val1, val2) => JSON.stringify(val1) === JSON.stringify(val2)
</script>
